import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Swal from 'sweetalert2';
import { FiLock, FiUser } from 'react-icons/fi';

const API_URL = 'https://app.thundermaxhome.com/api.php';

export default function AdminLoginPage() {
  // 🚀 1. ประกาศ State ทุกอย่างไว้บนสุดแบบนี้ครับ
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false); // ตัวแปรจำไอดีอยู่ตรงนี้ถูกต้องแล้วครับ
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      const res = await fetch(`${API_URL}?action=login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const data = await res.json();
      
      if (data.success && data.user) {
        
        // 🚀 2. ดักจับสิทธิ์ ถ้าเป็นช่าง (tech) ไม่ให้เข้าหลังบ้าน
        if (data.user.role === 'tech') {
           Swal.fire('ปฏิเสธการเข้าถึง', 'พื้นที่นี้สำหรับระดับผู้บริหารเท่านั้น!', 'error');
           setIsLoading(false);
           return;
        }
        
        // 🚀 3. ส่งข้อมูล user และค่า rememberMe เข้าไปในระบบสมองกล (Context)
        login(data.user, rememberMe);
        
        Swal.fire({
          title: 'เข้าสู่ระบบสำเร็จ',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          if (data.user.role === 'sales') {
            navigate('/sales');
          } else {
            navigate('/admin/dashboard'); // พาไปหน้าแดชบอร์ด
          }
        });

      } else {
        Swal.fire('เข้าสู่ระบบล้มเหลว', data.message || 'ไอดีหรือรหัสผ่านไม่ถูกต้อง', 'error');
      }
    } catch (error) {
      Swal.fire('ข้อผิดพลาด', 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0b0f19] flex items-center justify-center p-4 font-sans">
      <div className="w-full max-w-md bg-[#131825] rounded-3xl shadow-2xl border border-[#1e2330] p-8 animate-fade-in">
        
        <div className="text-center mb-8">
          <h1 className="text-3xl font-black text-blue-500 tracking-wider">THUNDER <span className="text-white">CRM</span></h1>
          <p className="text-xs text-gray-500 mt-2 font-bold uppercase tracking-widest">Admin Control Panel</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block text-xs font-bold text-gray-400 mb-1.5 uppercase">Username</label>
            <div className="relative">
              <FiUser className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500" />
              <input 
                type="text" 
                value={username} 
                onChange={(e) => setUsername(e.target.value)} 
                required
                className="w-full bg-[#1e2330] border border-[#334155] text-white text-sm rounded-xl py-3 pl-10 pr-4 focus:outline-none focus:border-blue-500 transition-colors"
                placeholder="กรอกชื่อผู้ใช้งาน"
              />
            </div>
          </div>

          <div>
            <div className="flex justify-between items-center mb-1.5">
              <label className="block text-xs font-bold text-gray-400 uppercase">Password</label>
            </div>
            <div className="relative">
              <FiLock className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500" />
              <input 
                type="password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required
                className="w-full bg-[#1e2330] border border-[#334155] text-white text-sm rounded-xl py-3 pl-10 pr-4 focus:outline-none focus:border-blue-500 transition-colors"
                placeholder="กรอกรหัสผ่าน"
              />
            </div>
          </div>

          {/* 🚀 4. Checkbox จำไอดี เชื่อมกับ State rememberMe แล้ว */}
          <div className="flex items-center gap-2 pt-2">
            <input 
              type="checkbox" 
              id="remember" 
              checked={rememberMe} 
              onChange={(e) => setRememberMe(e.target.checked)} 
              className="w-4 h-4 text-blue-600 rounded bg-[#1e2330] border-[#334155] focus:ring-blue-500"
            />
            <label htmlFor="remember" className="text-xs text-gray-400 font-bold cursor-pointer">
              จำการเข้าระบบไว้ในเครื่องนี้ (Remember Me)
            </label>
          </div>

          <div className="pt-4">
            <button 
              type="submit" 
              disabled={isLoading}
              className={`w-full py-3.5 rounded-xl font-bold text-sm text-white transition-all shadow-lg
                ${isLoading ? 'bg-blue-800 cursor-wait' : 'bg-blue-600 hover:bg-blue-500'}
              `}
            >
              {isLoading ? 'กำลังตรวจสอบ...' : 'เข้าสู่ระบบ CRM'}
            </button>
          </div>
        </form>

      </div>
    </div>
  );
}